require('./popupNotificationBrowser.i18n.json');
require('./popupNotificationBrowser.tpl.html');
require('./popupNotificationRepository.js');
require('./managePopupNotification/managePopupNotificationController.js');
require('./popupStateModel.js');
/*@ngInject*/
const PopupNotificationBrowserController = function ($scope, $rootScope, $state, $timeout, localization, coreConstant, configurationMediator, notificationPreferencesType, notificationPreferencesAction, navigationStateModel, modalUtil, configurationActionsUtil, databaseDownloadSectionName, popupStateModel) {

    localization.getTranslationByKey('popupNotificationBrowser').then(function (translations) {

        $scope.viewModel = {
            popupNotifications: null,
            totalPopupNotification: 0,
            recordCountText: _.get(translations, 'recordCountText'),
            recordsCountText: _.get(translations, 'recordsCountText'),
            isGridEmpty: true,
            requestParams: {
                key: 'name',
                startIndex: 0,
                pageSize: 25,
                sortType: 'asc',
                searchString: ''
            },
            searchPrompt: _.get(translations, 'searchPrompt'),
            shortDateTimeFormat: 'MM/dd/yy hh:mma'
        };

        $scope.actions = [];
        $scope.context = {
            identifier: 'popupNotificationBrowser',
            actions: {},
            fallthrough: null,
            model: {
                contextType: coreConstant.CONTEXT_NONE
            }
        };
        $scope.context.actions[coreConstant.CONTEXT_NONE] = '';

        function loadActions() {
            configurationMediator.loadPopupNotificationActions().then(function (actions) {
                const allActions = [];
                allActions.push({
                    actions: actions.actions,
                    contextType: $scope.context.model.contextType
                });
                $scope.actions = allActions;
                $scope.actionsTimeLastModified = new Date().getTime();
            });
        }

        function loadPopups() {
            $scope.viewModel.isLoading = true;
            configurationMediator.loadPopupNotification($scope.viewModel.requestParams).then(function (popupNotifications) {
                $scope.viewModel.popupNotifications = popupNotifications.records;
                $scope.viewModel.totalPopupNotification = popupNotifications.totalRecords;
                $scope.viewModel.isGridEmpty = $scope.viewModel.popupNotifications.length === 0;

                $timeout(function () {
                    $rootScope.$broadcast(coreConstant.event.RECALCULATE_GRID_PAGING);
                    $scope.viewModel.isLoading = false;
                }, 0);
            });
            popupStateModel.saveViewState('configuration.popupBrowser', null);
            navigationStateModel.saveViewState('configuration.popupBrowser', null);
        }

        function checkPreviousViewState() {
            popupStateModel.restoreViewState($state.name, $scope.viewModel);
            loadPopups();
        }

        $scope.onPagingChange = function ($event, params) {
            $scope.viewModel.requestParams.startIndex = params.startIndex;
            popupStateModel.saveViewState('configuration.popupBrowser', null);
            loadPopups();
        };

        $scope.onSortChange = function (event, params) {
            $scope.viewModel.requestParams.key = params.key;
            $scope.viewModel.requestParams.sortType = params.sortType;
            popupStateModel.saveViewState('configuration.popupBrowser', null);
            loadPopups();
        };

        $scope.onClickRow = function (event, item) {
            let navigationModel = {
                parentState: 'configuration.popupBrowser',
                currentState: 'configuration.managePopup',
                data: {
                    templateId: item.id
                }

            };
            $state.go('configuration.managePopup', {
                templateId: item.id
            });
            popupStateModel.saveViewState(navigationModel.parentState, $scope.viewModel);
            navigationStateModel.saveViewState(navigationModel.parentState, navigationModel);
        };

        $scope.onSearchInputChange = _.debounce(function () {
            $scope.viewModel.requestParams.startIndex = 0;
            $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
            loadPopups();
        }, 200);

        $scope.$on('$destroy', function () {
            popupStateModel.saveViewState($state.name, $scope.viewModel);
        });

        $scope.onClearSearchTerm = function () {
            $scope.viewModel.requestParams.searchString = '';
            $scope.viewModel.requestParams.startIndex = 0;
            $rootScope.$broadcast(coreConstant.event.RESET_GRID_PAGING);
            loadPopups();
        };

        $scope.getStatus = function (item) {
            return (item.enabled) ? _.get(translations, 'status.active') : _.get(translations, 'status.inactive');
        };

        $scope.handleAction = function (action, file) {
            if (action.enabled) {
                switch (action.name) {
                    case notificationPreferencesAction.NEW_POPUP:
                        $state.go('configuration.managePopup');
                        break;

                    case notificationPreferencesAction.BACKUP:
                        configurationActionsUtil.backup(databaseDownloadSectionName.NOTIFICATION_POPUP_TEMPLATES, _.get(translations, 'backup.name'), _.get(translations, 'backup.loadingBar'), _.get(translations, 'backup.successMessage'));
                        break;

                    default:
                        modalUtil.showActionNotImplementedModal(action.name);
                        break;
                }
            }
        };

        loadActions();
        checkPreviousViewState();
    });

    $scope.$on(ux.datagrid.events.ON_STARTUP_COMPLETE, function () {
        $scope.$apply();
    });
};

angular.module('ums.configuration')
    .controller('popupNotificationBrowserController', PopupNotificationBrowserController);
